const Tactic = require('../../entities/Tactic');
const { Age }  = require("../Constants");
const TacticNames = require("../Names/TacticNames");

class HeavyCavalry extends Tactic {
    constructor() {
        super(
            Age.Age1,
            TacticNames.HeavyCavalry,
            [0, 3, 0],
            "4",
            {}
        )
    }
}

module.exports = HeavyCavalry;